import { useMutation } from '@gogame/query';

import { exportAssistedInstalls } from 'scenes/AssistedInstalls/source/assistedInstalls';

import { exportAI } from '../queryKeyFactory';

export const useExportAssistedInstalls = () => {
  const exportMutations = useMutation(exportAI(), exportAssistedInstalls, {
    successMessage: () => `Export completed`,
    errorMessage: (e) => e.message,
    mutateMessage: () => `Export has started`,
  });

  return [exportMutations.mutateAsync, exportMutations];
};
